import { HttpContextToken } from '@angular/common/http';

// Allow callers with their own recovery UI to receive errors instead of EMPTY.
export const HANDLE_HTTP_ERRORS_LOCALLY = new HttpContextToken(() => false);
